import useStyles from "./ToDoListStyle";
import { Typography } from "@material-ui/core";
import { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import ShowArticleCard from "./ShowArticleCard";
import ToDoListService, { ToDoListServiceType } from "./ToDoListService";
import LabelsContext from "../../../lang/LabelsContext";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ToDoList() {
  const classes = useStyles();
  const theme = useTheme();
  const { Labels } = LabelsContext();
  const [value, setValue] = useState(0);
  const {
    assignReviewers,
    decide,
    overdueReviewers,
    overdueAssociate,
    returnedToEditor,
    underReview,
  }: ToDoListServiceType = ToDoListService();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const tabsLabelValue = [
    { label: Labels.ASSIGN_REVIEWERS, value: assignReviewers },
    { label: Labels.UNDER_REVIEW, value: underReview },
    { label: Labels.DECIDE_ON_STATUS, value: decide },
    { label: Labels.OVERDUE_REVIEWERS, value: overdueReviewers },
    { label: Labels.OVERDUE_AES, value: overdueAssociate },
    { label: Labels.RETURNED_TO_EDITOR, value: returnedToEditor },
  ];

  const tabsToShow = tabsLabelValue.filter((x: any) => x.value);

  return (
    <div className={classes.root}>
      <Typography variant="h5">{Labels.TO_DO_LIST}</Typography>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          {tabsToShow.map((obj: any, i: number) => {
            return <Tab key={i} label={`${obj.label} (${obj.value.length})`} {...a11yProps(i)} />;
          })}
        </Tabs>
      </AppBar>
      {tabsToShow.map((data: any, i: number) => {
        return (
          <TabPanel key={i} value={value} index={i} dir={theme.direction}>
            <ShowArticleCard label={data.label} articleData={data.value} />
          </TabPanel>
        );
      })}
    </div>
  );
}
